/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".demo-img[_ngcontent-%COMP%]{width:100%;height:100%}.center-block[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto;text-align:center;margin-top:20px;float:none}.demo-btn[_ngcontent-%COMP%]{font-size:21px}@media (min-width:768px){.mobile-img[_ngcontent-%COMP%]{display:none}}@media (max-width:768px){.desktop-img[_ngcontent-%COMP%]{display:none}.center-block[_ngcontent-%COMP%]{width:65%}.demo-link[_ngcontent-%COMP%]{margin-bottom:4%}}"];
export { styles as styles };
